<template>
  <div id="app">
    <div id="pageContent" class="pageContent_2lAGg">
      <div class="pdfContent_1PW2f">
        <!-- 头部 -->
        <div class="pdf-header">
          <div class="input">
            pdf签章盖章<a href="https://item.taobao.com/item.htm?ft=t&id=1018343499362">源码购买</a>
          </div>
          <div class="input">
            {{ page_num }}
            <span>Page: <input type="text" class="input-text" v-model="page_num" placeholder="1"> /
              {{ page_count }}</span>
            <el-button @click="jump" type="text">跳转</el-button>
            <el-button size="mini" @click="savepdf" type="primary">下载pdf</el-button>
            <!--<span>全屏</span>-->
          </div>
        </div>
        <!-- pdf展示区 -->
        <div v-show="!pdfUrl">
            <div style="width: 100%;text-align: center;margin-top: 150px;">
              <div>本系统纯前端界面，不会上传文件到服务器，请放心使用</div>
            </div>
          </div>
        <div v-show="pdfUrl" class="pdf-container" ref="pdfBox" v-loading="!isShow" element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.1)">

          <div class="pdf-box">
            <div class="pdfPage_padd" v-for="page in page_count" :key="page" :class="{ 'page__edges_padding': (showEdges && page == 1) }">
              <div class="pdfPage_svgbox">
                <template v-if="page_pdf_arr[page - 1]">
                  <div class="pdfPage_flex">
                    <span class="pdfPage_svg" @click="openpdf(page)">
                      <i style="color:#0282e5;font-size: 16px;" class="el-icon-zoom-in"></i>
                    </span>
                    <span class="pdfPage_svg" @click="signpdfgz(page, page_pdf_arr[page - 1])" v-if="page_pdf_arr[page - 1].show">
                      <svg t="1708402106688" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4306" width="16" height="16"><path d="M925.04 856.92H98.48c-18.9 0-34.48-16.01-34.48-35.7V642.94c0-58.85 46.49-106.99 103.32-106.99h220.43c-6.9-42.85-27.58-83.85-56.83-119.43-39.59-46.42-60.28-105.27-60.28-165.85 0-67.72 25.8-131.98 74.07-180.12C392.98 22.4 454.93-0.74 522.1 0.98c124.01 5.3 229 115.86 230.78 244.27 1.67 64.15-22.35 126.57-63.73 174.71-29.25 32.14-46.49 71.29-53.39 115.98H856.2c56.84 0 103.32 48.14 103.32 106.99v178.28c0 19.7-15.45 35.71-34.48 35.71z m-792.2-71.29h757.72v-142.7c0-19.58-15.45-35.71-34.48-35.71H597.84c-18.9 0-34.48-16-34.48-35.7 0-74.86 25.8-146.27 74.07-199.7 31.03-33.86 46.49-78.43 46.49-124.85-1.67-92.71-75.74-171.26-165.39-174.71-48.27-1.73-92.98 16-125.67 49.99-34.48 33.86-53.39 80.27-53.39 128.41 0 42.85 15.46 85.57 43.04 117.7 49.94 58.85 77.52 130.14 77.52 203.28 0 19.57-15.46 35.7-34.48 35.7H167.32c-18.9 0-34.48 16-34.48 35.7v142.59zM960 994v-23c0-16.5-13.5-30-30-30H94c-16.5 0-30 13.5-30 30v23c0 16.5 13.5 30 30 30h836c16.5 0 30-13.5 30-30z" p-id="4307" fill="#0282e5"></path></svg>
                    </span>
                  </div>
                </template>
              </div>
              <div class="pdfPage_1yRne"
                :style="{ width: page_pdf_arr[page - 1].pdfWidth + 'px', height: page_pdf_arr[page - 1].pdfHeight + 'px' }">
                <canvas class="pdf-item" :id="'the-canvas' + page"></canvas>
                <div class="dragLayer_3ccsq" :id="'can' + page" :class="'can' + page"></div>
                <!--骑缝章区域位置 -->
                <!-- <transition name="slide-fade">
                  <div v-show="showEdges && page == 1" :id="'edge_' + page"
                    :class="{ 'es-pdf-page__edges--visible': signEdges }" class="es-pdf-page__edges" style="width: 120px;"
                    :style="{ width: slideWidth + 'px', height: page_pdf_arr[page - 1].pdfHeight + 'px', border: '2px dashed red' }">
                  </div>
                </transition> -->
              </div>
              <div class="pdf_page_bottom">
                <div class="pdf_page_bottom_ye">第{{ page }}页</div>
                <div class="pdf_page_bottom_ye" v-if="page_pdf_arr[page - 1]">{{ page_pdf_arr[page - 1]['view'].width }} x
                  {{ page_pdf_arr[page - 1]['view'].height }} 毫米</div>
              </div>
            </div>
          </div>
          <div class="bottom-btn" @click="changesignqz"><span>{{ showEdges ? '单页盖章' : '骑缝签章' }}</span></div>
        </div>
      </div>

      <!-- 右侧 -->
      <div class="taskInfoArea_3ThxW">
        <div class="tab-bar">
          <el-tabs v-model="activeName" :stretch="true">
            <el-tab-pane label="我的印章" name="1"></el-tab-pane>
            <el-tab-pane label="AI助手" name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="tab-context">
          <div v-show="activeName == 1">
            <div style="padding: 20px;">
              <div style="border: 1px dashed gray;">
                <el-upload class="avatar-uploader" action="" :show-file-list="false" :auto-upload="false" accept="application/pdf" :on-change="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                  <img v-if="firstPageImg" :src="firstPageImg" class="avatar">
                  <div v-else class="upfilenbtn"><el-button type="primary"><i class="el-icon-upload2"></i>上传pdf文件</el-button></div>
                  <span v-if="upfilename" class="upfilename">文件：{{ upfilename }}</span>
                </el-upload>
              </div>
              <div>本系统纯前端界面，不会上传文件到服务器，请放心使用</div>
            </div>
            <div class="singnbuton">
              <div class="singnbuton_bt" @click="uploadfile">
                <span><svg t="1702433213436" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4310" width="20" height="20">
                    <path
                      d="M875.5 928h-727c-28.4 0-51.5-23-51.5-51.5h830c0 28.5-23.1 51.5-51.5 51.5zM926.4 857.5H97.6V709.3c0-25 9.9-47 28.7-63.6 13.7-12.2 32.4-21.7 57-29.2l1-0.3L317 585.5c52.7-16.3 59.8-36.1 59.8-53.3v-88.8c0-5.5-2.2-10.5-6.2-14.3-23.8-22.2-42.3-49.9-53.5-80.1-11.9-32.2-15.6-66.1-10.9-100.8 6.1-45 27.7-87.5 60.8-119.8 33-32.3 76.1-52.9 121.1-57.9 30.4-3.4 60.3-0.4 88.9 8.9 27.4 9 52.2 23.3 73.8 42.6 44.1 39.4 69.4 95.9 69.4 155 0 28.7-5.8 56.6-17.2 82.7-11 25.2-26.7 47.7-46.6 66.9-5.7 5.5-8.8 12.5-8.8 19.7v85.8c0 16.4 4.7 35.5 60 53.3l133.1 30.8 1.5 0.5c19.3 6.7 41.2 15.6 57.5 30.1 18 16.1 27.1 37.1 27 62.4v148.3z m-770.8-58h712.8v-90.3c0-13.4-2.9-22.7-44.1-37.2L692 641.4l-1.1-0.4c-30.8-9.8-52.7-21.1-68.8-35.4-21.7-19.3-32.7-44-32.7-73.5v-85.8c0-23.1 9.4-45 26.6-61.5 29.7-28.5 46-66.8 46-107.8 0-42.6-18.2-83.4-50-111.8-32.3-28.8-74-42-117.5-37.1-66.8 7.5-121.8 61.3-130.9 127.9-6.7 49.3 10.2 96.9 46.4 130.6 15.7 14.6 24.7 35.3 24.7 56.7v88.8c0 29.5-11.2 54.4-33.4 74-16.4 14.5-38.7 26-68.4 35l-1 0.3-1 0.2-131.7 30.5c-43.6 13.5-43.6 29.4-43.6 37.1v90.3z"
                      p-id="4311" fill="#ffffff"></path>
                  </svg></span>
                <span>选择印章图片文件</span>
              </div>
              <div style="width: 0;height: 0;">
                <input style="width: 0;height: 0;" ref="uploadInput" type="file" name="" @change="getbaseurl">
              </div>
            </div>
            <div class="opensignimgs">
              <div class="seal-box" v-if="signimage.url">
                <div class="seal-wrapper-item" :style="{ width: signimage.width + 'px', height: signimage.height + 'px' }">
                  <div ref="signimg" class="sign-img" :style="{ width: signimage.width + 'px', height: signimage.height + 'px' }"
                    :data-width="signimage.width" :data-height="signimage.height">
                    <img style="width: 100%;height: 100%;" :src="signimage.url" alt="">
                    <div class="delete" @click.stop="deleteIt">删除</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-show="activeName == 2">
            <AIAssistant :pdf-text="pdfText" />
          </div>

        </div>
      </div>
    </div>

    <!-- 用于计算骑缝章大小,默认不显示并隐藏 style="" -->
    <div id="avatarPreview" style="opacity: 0;height: 0px;width: 0px;padding-left: 1px;display: none;">
      <canvas id="canvas-3"></canvas>
    </div>

    <!-- 印章弹窗 -->
      <!-- <fileRaw ref="fileRaw" ></fileRaw> -->
    <tabsindex ref="tabsindex" @changesignimg="changesignimg"></tabsindex>

    <!-- 预览 -->
    <el-dialog class="lookpdfmsg" title="" :visible.sync="dialogVisible2" :width="dialogVisible_width"
      @close="dialogVisible_close">
      <div class="lookpdfmsg_div">
        <canvas id="lookcanvas"></canvas>
        <div class="dragLayer_3ccsq move_canvas"></div>
      </div>
    </el-dialog>

    <!-- 骑缝章 -->
    <el-dialog class="lookpdfmsg2" title="" :visible.sync="dialogVisible3"  :width="dialogVisible_width2" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="lookcanvasdiv" v-if="page_pdf_arr.length > 0" style="padding: 20px;" >
        <div class="lookcanvasdiv2" :style="{ width: openpdf_qifenview.width, height: openpdf_qifenview.height}">
          <canvas id="lookcanvas2"></canvas>
          <div class="dragLayer_3ccsq move_canvas2"></div>
          <!--骑缝章区域位置 -->
          <transition name="slide-fade">
            <div v-show="showEdges" id="edge_1"
              :class="{ 'es-pdf-page__edges--visible': signEdges }" class="es-pdf-page__edges" style="width: 120px;"
              :style="{ width: slideWidth + 'px', height: openpdf_qifenview.height, border: '2px dashed red' }">
            </div>
          </transition>
          <div class="addqfsign" :style="{ right: -(slideWidth*1+20) + 'px'}" @click="signpdfgz(1, page_pdf_arr[0])">盖章</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="closedialogVisible3">取 消</el-button>
        <el-button type="primary" @click="suredialogVisible3">确 定</el-button>
      </div>
    </el-dialog >

    <!-- <SignaturePad></SignaturePad> -->

  </div>
</template>

<script>
import tabsindex from './components/tabsindex.vue';
import AIAssistant from './components/AIAssistant.vue';
// import SignaturePad from './components/SignaturePad.vue';
// 使用cdn 引入pdfjs npm引入pdflib版本一直有问题
let PDFJS = pdfjsLib;
PDFJS.GlobalWorkerOptions.workerSrc = './pdflist/pdf/build/pdf.worker.js'

export default {
  name: 'App',
  components:{
    tabsindex,
    AIAssistant
    // SignaturePad
  },
  data() {
    return {
      isShow: false,
      setFlag: false,
      signimage: {
        url: '',
        width: '',
        height: '',
      },
      signEdges: false, //
      showEdges: false, //单页或骑缝章
      count: 0,
      dom: null,
      scrollTop: 0,
      activeName: "1",
      pdfUrl: "",// 这里是pdf文件地址，后台给的流文件请求地址也是可以的
      pdfDoc: null,// pdfjs 生成的对象
      pageNum: 1,//
      // scale: 1.0,// 放大倍数
      scale: 0.5,
      page_num: 0,// 当前页数
      page_count: 0,// 总页数
      pdfWidth: 0,
      pdfHeight: 0,
      slideWidth: 120,
      right: true,
      left: true,
      code: "",
      pos_x: '',
      pos_y: '',
      posPage: '',
      seal_id: '',

      // pdf 数据
      pdfbase64: '',
      pdfbase64_data: '',
      pdfData: null,
      page_pdf_arr: [], //单页盖章
      page_pdf_arr2: [], //骑缝章
      //印章裁剪
      dialogVisible: false,
      imageUrl: '',
      cropperInstance: null,
      croppedBase64: '',
      cropSize: 150, // 默认裁剪尺寸
      rotationDegree: 0, // 旋转角度，默认0度
      lastRotation: 0, // 记录上一次旋转角度，用于计算相对旋转
      //预览
      dialogVisible2: false,
      openpdf_index: null,
      dialogVisible_width: '',
      renderTasks: {}, // 用于存储每个页面的渲染任务
      firstPageImg:'',
      upfilename:'',
      dialogVisible3:false,

      openpdf_qifenview:{width:0,height:0},
      dialogVisible_width2:'',
      // ai助手
      pdfText: '', // 新增：PDF全本文本（传给AI助手）
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.codeTimer) {
      clearInterval(this.codeTimer);
    }
  },
  mounted() {},
  watch: {
    scale(new1, old1) {
      document.querySelectorAll(".mark").forEach((item) => {
        item.style.left = (parseInt(item.style.left) / (old1 / new1)) + "px";
        item.style.top = (parseInt(item.style.top) / (old1 / new1)) + "px";
        item.style.height = 100 * new1 + "px";
        item.style.width = 100 * new1 + "px";
      });
      document.querySelectorAll(".text_mark").forEach((item) => {
        item.style.left = (parseInt(item.style.left) / (old1 / new1)) + "px";
        item.style.top = (parseInt(item.style.top) / (old1 / new1)) + "px";
        item.style.height = 28 * new1 + "px";
        item.style.width = 190 * new1 + "px";
      });
      document.querySelectorAll(".text_mark2").forEach((item) => {
        item.style.left = (parseInt(item.style.left) / (old1 / new1)) + "px";
        item.style.top = (parseInt(item.style.top) / (old1 / new1)) + "px";
        item.style.height = 100 * new1 + "px";
        item.style.width = 100 * new1 + "px";
      });
      this.slideWidth = 120 * new1;
    },
  },
  methods: {
    handleAvatarSuccess(file, fileList) {
      console.log(file)
      let that = this;
      this.$nextTick(function () {
        that.upfilename = file.name;
        that.pdfUrl = URL.createObjectURL(file.raw)
        that.download(this.pdfUrl, file.name, false);
        that.$refs.pdfBox.addEventListener("scroll", that.handleScroll, false);
      });
    },
    beforeAvatarUpload(file) {
      // console.log(file)
      const ispdf = file.type === 'application/pdf';
      const isLtM = file.size / 1024 / 1024 < 100;

      if (!ispdf) {
        this.$message.error('只能上传PDF格式!');
      }
      if (!isLtM) {
        this.$message.error('文件大小不能超过 100MB!');
      }
      return ispdf && isLtM;
    },
    //上传pdf文件，进行预览操作
    uploadpdffile() {

    },
    uploadfile() {
      // 原本直接上传，发现图片cm 显示特别大
      // this.$refs.uploadInput.click()

      //使用裁剪
      // this.dialogVisible = true;
      this.$refs.tabsindex.dialogVisible = true
    },
    getbaseurl(e) {
      const imgFile = e.target.files[0];
      if (imgFile) {
        const isLt1M = imgFile.size / 10240 / 10240 < 10;
        if (!isLt1M) {
          this.$message.error('上传图片大小不能超过10Mb!');
          return
        }
        let that = this;
        const reader = new FileReader();
        reader.readAsDataURL(imgFile);
        reader.onload = (e) => {
          that.$message.success('上传图片成功');
          that.signimage.url = reader.result
          // that.signimageurl=reader.result.replace(/^data:image\/\w+;base64,/, '');
          that.$refs.uploadInput.value = null;
          var img = new Image();
          img.onload = function () {
            console.log('图片宽度: ' + img.width + ', 图片高度: ' + img.height);
            that.signimage.width = img.width;
            that.signimage.height = img.height;
          };
          img.src = e.target.result;
        };
      }
    },
    mouseenter(e) {
      e.currentTarget.childNodes[1].style.display = "block";
    },
    mouseleave(e) {
      e.currentTarget.childNodes[1].style.display = "none";
    },
    deleteIt(e) {
      const index = e.currentTarget.parentNode.getAttribute('data-page');
      const itemname = e.currentTarget.parentNode.getAttribute('id');
      delete this.page_pdf_arr[index]['canvasobj'][itemname]
      e.currentTarget.parentNode.parentNode.removeChild(e.currentTarget.parentNode);
    },
    deleteIt2(e) {
      console.log('deleteIt2', e.currentTarget.parentNode)

      const index = e.currentTarget.parentNode.getAttribute('data-page');
      const itemname = e.currentTarget.parentNode.getAttribute('id');
      delete this.page_pdf_arr2[itemname]
      document.querySelectorAll(`[data-id="${itemname}"]`).forEach((item) => {
        item.parentNode.removeChild(item);
      });
      e.currentTarget.parentNode.parentNode.removeChild(e.currentTarget.parentNode);
      // document.querySelectorAll(".slide-sign").forEach((item) => {
      //   item.parentNode.removeChild(item);
      // });
    },
    moveTo(e) {
      console.log('moveTo', e)
      let odiv = e.currentTarget; //获取目标元素
      let pageindex = odiv.getAttribute('data-page');
      let odivid = odiv.id;
      let odiv2 = odiv.parentNode;
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //限制区域
        // if (left <= 0) {
        //     left = 0;
        // } else if (left >= document.querySelector(".pdf-box").clientWidth - odiv.clientWidth) {
        //     left = document.querySelector(".pdf-box").clientWidth - odiv.clientWidth;
        // }

        if (left <= 0) {
          left = 0;
        } else if (left >= odiv2.clientWidth - odiv.clientWidth) {
          left = odiv2.clientWidth - odiv.clientWidth;
        }

        if (top <= 0) {
          top = 0;
        } else if (top >= odiv2.clientHeight - odiv.clientHeight) {
          top = odiv2.clientHeight - odiv.clientHeight;
        }

        //移动当前元素
        this.pos_x = left;
        this.pos_y = top;
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";

        //@zfbug 多次扣章 出现问题，只保存最后一次，没有记录上一个章信息
        this.page_pdf_arr[pageindex].canvasobj[odivid] = {
          x: left,
          y: top,
          id: odivid,
        }
      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    moveTo2(e) {
      let odiv = e.currentTarget; //获取目标元素
      let pageindex = odiv.getAttribute('data-page');
      let odivid = odiv.id;
      let odiv2 = odiv.parentNode;
      //算出鼠标相对元素的位置
      let disX = e.clientX - odiv.offsetLeft;
      let disY = e.clientY - odiv.offsetTop;
      document.onmousemove = e => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //限制区域
        if (left <= 0) {
          left = 0;
        } else if (left >= odiv2.clientWidth - odiv.clientWidth) {
          left = odiv2.clientWidth - odiv.clientWidth;
        }

        if (top <= 0) {
          top = 0;
        } else if (top >= odiv2.clientHeight - odiv.clientHeight) {
          top = odiv2.clientHeight - odiv.clientHeight;
        }

        //移动当前元素
        this.pos_x = left;
        this.pos_y = top;
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";

        this.page_pdf_arr2[odivid] = {
          width: odiv.getAttribute('data-width'),
          height: odiv.getAttribute('data-height'),
          x: left*this.scale,
          y: top*this.scale,
          id: odivid,
          moveoff:true,
        }

      };
      document.onmouseup = e => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    handleScroll(el) {
      this.scrollTop = this.$refs.pdfBox.scrollTop;
      // let _pdfs = document.querySelectorAll(".pdfPage_1yRne");
      //因为有padding 15px 所有要减去15
      let _pdfs = document.querySelectorAll(".pdfPage_padd");
      let arr = [];
      _pdfs.forEach((item, index) => {
        if (this.scrollTop >= (item.offsetTop - 15)) {
          arr.push(index);
        }
      });
      this.page_num = Math.max.apply(null, arr) + 1;
    },
    jump() {
      let that = this;
      let index = this.page_num - 1;
      if (index > this.page_count) {
        this.$message.error("请输入有效范围内的数字");
        return;
      }
      // 用 class="pdfPage_padd" 添加锚点
      let jump = document.querySelectorAll(".pdfPage_padd");
      let total = jump[index].offsetTop - 15;
      console.log('total', total)
      console.log('纵坐标', total)
      let distance = this.scrollTop;
      console.log('distance', distance)
      //平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = total / 30 >> 0;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 30 >> 0;
        smoothUp();
      }

      function smoothDown() {
        if (distance < total) {
          distance += step;
          that.$refs.pdfBox.scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          that.$refs.pdfBox.scrollTop = total;
        }
      }

      function smoothUp() {
        if (distance > total) {
          distance -= step;
          that.$refs.pdfBox.scrollTop = distance;
          setTimeout(smoothUp, 10);
        } else {
          that.$refs.pdfBox.scrollTop = total;
        }
      }
    },
    _renderPage(num) {
      console.log('_renderPage',num)
      const that = this;
      this.pdfDoc.getPage(num).then(function(page) {
        //@zf 记录pdf宽高信息
        that.page_pdf_arr[num - 1].view = {
          width: (page._pageInfo.view[2] * 25.4 / 72).toFixed(0),
          height: (page._pageInfo.view[3] * 25.4 / 72).toFixed(0),
        }
        const canvas = document.getElementById(`the-canvas${num}`);
        if (!canvas) {
          console.error(`Canvas for page ${num} not found`);
          return;
        }
        const ctx = canvas.getContext('2d');

        // 获取页面尺寸并设置canvas大小 
        // const viewport = page.getViewport({ scale: that.scale });
        // canvas.height = viewport.height;
        // canvas.width = viewport.width;

        //调整清晰度
        let viewport_scale = page.getViewport(that.scale);
        let viewport = page.getViewport(2);
        let v_s_num = that.scale / 2;

        that.page_pdf_arr[num - 1].pdfHeight = viewport_scale.height;
        that.page_pdf_arr[num - 1].pdfWidth = viewport_scale.width;

        canvas.height = viewport.height;
        canvas.width = viewport.width;
        canvas.style.height = viewport.height * v_s_num + 'px';
        canvas.style.width = viewport.width * v_s_num + 'px';

        canvas.setAttribute('data-width', page._pageInfo.view[2])
        canvas.setAttribute('data-height', page._pageInfo.view[3])


        // 渲染上下文配置
        const renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };

        // 执行渲染，确保前一个渲染完成后再渲染下一页
        const renderTask = page.render(renderContext);
        
        // 等待当前页渲染完成后再渲染下一页
        renderTask.promise.then(() => {

          // 记录当前页已渲染完成
          that.renderTasks[num] = true;
          // 渲染下一页（如果存在且未渲染）
          // if (num < that.page_count && !that.renderTasks[num + 1]) {
          //   that._renderPage(num + 1);
          // }

          if (num === 1) {
            // 从canvas获取图片base64 URL
            that.firstPageImg = canvas.toDataURL('image/png');
            // 此时可在右侧列表使用that.firstPageImg展示
          }

        }).catch(err => {
          console.error(`渲染第${num}页失败:`, err);
          
        });

        // 不等待当前界面，进行下一个界面渲染,出现bug有可能渲染失败
        if (num < that.page_count) {
          that._renderPage(num + 1);
        }
        
      });
    },
    download(url, filename, stat) {
      var that = this;

      that.getBlob(url).then(function (blob) {

        that.convertBlobToBase64(blob).then((base64String) => {
          that.pdfbase64 = base64String;
          let data = atob(
            base64String.substring(base64String.indexOf(',') + 1)
          );
          that.pdfbase64_data = data;
          that._loadFile(data);
        }).catch((err) => {
          console.error(err)
        });
      });
    },
    saveAs(blob, filename, stat) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        const body = document.querySelector('body');
        console.log(blob)

        link.href = window.URL.createObjectURL(blob);
        console.log('href', link.href)
        //link.href =blob;
        link.download = filename;
        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);


      }
    },
    getBlob(url) {
      var that = this;
      return new Promise(function (resolve) {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            if (xhr.status === 200) {
              resolve(xhr.response);
            } else {
              that.$message.error("复制失败")
            }
          }
        };
        xhr.onprogress = function (event) {
          if (event.lengthComputable) {
            var pre = parseInt(event.loaded / event.total * 100) + '%';
            console.log(pre)
            // layui.element.progress('downprecent', pre);
          }
        };
        xhr.send();
      });
    },
    convertBlobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(blob);
      });
    },
    // 新增：提取PDF全本文本（遍历所有页面，传给AI助手）
    async _extractPdfText() {
      if (!this.pdfDoc) return;
      this.$message.info('正在提取PDF文本，AI将基于文本为你答疑...');
      let fullText = '';
      for (let i = 1; i <= this.page_count; i++) {
        try {
          const page = await this.pdfDoc.getPage(i);
          const textContent = await page.getTextContent();
          // 拼接单页文本
          const pageText = textContent.items.map(item => item.str).join(' ');
          fullText += `第${i}页：${pageText}\n\n`;
        } catch (err) {
          console.error(`提取第${i}页文本失败：`, err);
          this.$message.warning(`提取第${i}页文本失败，不影响整体分析`);
        }
      }
      this.pdfText = fullText; // 存储PDF全本文本
      this.$message.success('PDF文本提取完成，可以使用AI助手了！');
    },
    _loadFile(data) {
      var that = this
      var CMAP_URL = './pdflist/pdf/cmaps/';

      this.pdfData = PDFJS.getDocument({
        // url: url, 
        data: data, // PDF base64编码
        cMapUrl: CMAP_URL,
        cMapPacked: true
      }).then((pdf) => {
        this.pdfDoc = pdf;
        this.page_count = this.pdfDoc.numPages;
        //@zf 记录pdf基本信息
        for (var i = 0; i < this.page_count; i++) {
          this.page_pdf_arr.push({
            page: i + 1,
            show: true,
            index: i,
            canvas: null,
            view: {},
            canvasobj: {},
            scale: this.scale,
            pdfHeight: 0,
            pdfWidth: 0,
          })
        }
        this.$nextTick(() => {
          this.isShow = true;
          this._renderPage(1);
          // this._extractPdfText(); // 新增：PDF渲染后立即提取文本
        });
        this.pageNum = 1;
      });
    },
    queueRenderPage(num) {
      this._renderPage(num);
    },
    downpdf() {//下载pdf
      window.open(this.pdfUrl);
    },
    // 添加印章
    signpdfgz(index, item) {
      console.log(index, item)
      var that = this
      if (!this.signimage.url) {
        return this.$message.error('请上传图片');
      }
      if (this.showEdges) {
        console.log('进入骑缝章')
        this.signEdges = true;
        let e = this.$refs.signimg;
        let dom = e.cloneNode(true);
        // console.log(dom)
        let left = 0;
        let top = 0;
        this.pos_x = left;
        this.pos_y = top;
        dom.style.position = 'absolute'
        dom.style.left = left + "px";
        dom.style.top = top + "px";
        // dom.style.height = e.getAttribute('data-height') * this.scale + "px";
        // dom.style.width = e.getAttribute('data-width') * this.scale + "px";
        dom.style.height = e.getAttribute('data-height') * 1 + "px";
        dom.style.width = e.getAttribute('data-width') * 1 + "px";
        this.slideWidth = e.getAttribute('data-width'); //把骑缝章区域改为印章宽度
        document.onmousemove = null;
        document.onmouseup = null;
        document.querySelector('#edge_1').appendChild(dom);
        // dom.className = "sign-img mark slide-sign qifengzhang";
        dom.className = "mark slide-sign qifengzhang";
        dom.onmousedown = this.moveTo2;
        dom.onmouseenter = this.mouseenter;
        dom.onmouseleave = this.mouseleave;
        dom.setAttribute('data-page', item.index)
        //添加一个随机id
        const odivid = this.GetRandStr(5);
        dom.id = 'signedge_' + odivid;
        dom.childNodes[1].onclick = this.deleteIt2;

        this.page_pdf_arr2['signedge_' + odivid] = {
          width: dom.getAttribute('data-width'),
          height: dom.getAttribute('data-height'),
          x: 0,
          y: 0,
          id: odivid,
        }
      } else {
        let e = this.$refs.signimg;
        let dom = e.cloneNode(true);
        let left = 0;
        let top = 0;
        this.pos_x = left;
        this.pos_y = top;

        dom.style.left = left + "px";
        dom.style.top = top + "px";
        dom.style.height = e.getAttribute('data-height') * this.scale + "px";
        dom.style.width = e.getAttribute('data-width') * this.scale + "px";
        document.querySelector('#can' + index).appendChild(dom);
        document.onmousemove = null;
        document.onmouseup = null;
        dom.onmouseenter = this.mouseenter;
        dom.onmouseleave = this.mouseleave;
        dom.onmousedown = this.moveTo;
        dom.style.display = 'block';
        dom.setAttribute('data-page', item.index)
        //添加一个随机id
        const odivid = this.GetRandStr(5);
        dom.id = 'sign_' + odivid;
        //添加删除方法
        dom.childNodes[1].onclick = this.deleteIt;

        this.page_pdf_arr[index - 1].canvasobj['sign_' + odivid] = {
          x: 0,
          y: 0,
          id: odivid,
        }
      }


    },
    async savepdf() {
      var that = this;

      //查看是否执行骑缝章操作
      if(this.showEdges){
        //执行一下骑缝章扣章操作
        this.changesignqz(true)
        return false;
      }

      const pdfDoc = await PDFLib.PDFDocument.load(that.pdfbase64);
      const pages = pdfDoc.getPages();
      console.log('pages', pages)
      for (let i = 0; i < pages.length; i++) {
        let canvas = document.getElementById("the-canvas" + (i + 1));

        //添加正常扣章
        var sildesvg = document.querySelectorAll('.sign-img[data-page="' + i + '"]')
        if (sildesvg.length > 0) {
          //存在一页扣章多次
          for (let r = 0; r < sildesvg.length; r++) {
            console.log(sildesvg[r])
            const signid = sildesvg[r].id;
            const qianzhang_base64 = sildesvg[r].firstElementChild.src;
            let v_s_num = that.scale / 2;
            const eleImgCover = await pdfDoc.embedPng(qianzhang_base64);
            const width = sildesvg[r].getAttribute('data-width') * 1;
            const height = sildesvg[r].getAttribute('data-height') * 1;
            console.log(that.page_pdf_arr)
            // var thisx = that.page_pdf_arr[i].x / that.scale;
            //图片y轴在底部绘画  pdf文件高度 - 图片高度 - 印章高度
            // var thisy = ( canvas.getAttribute('height') / that.scale ) - that.page_pdf_arr[i].y - height
            // var thisy = (((canvas.getAttribute('height') * v_s_num) - that.page_pdf_arr[i].y) / that.scale) - height;
            // console.log(pages[i].drawImage())

            var thisx = that.page_pdf_arr[i].canvasobj[signid].x / that.scale;
            var thisy = (((canvas.getAttribute('height') * v_s_num) - that.page_pdf_arr[i].canvasobj[signid].y) / that.scale) - height;
            console.log(thisx, thisy)

            pages[i].drawImage(eleImgCover, {
              x: thisx,
              y: thisy,
              width: width,
              height: height,
            });
          }
        }

        //添加骑缝章
        // let sildesvg2 = document.getElementById("can" + (i + 1)).children;
        var sildesvg2 = document.querySelectorAll('.qifengsign-img[data-page="' + i + '"]')
        if (sildesvg2.length > 0) {
          //存在一页扣章多次
          for (let r = 0; r < sildesvg2.length; r++) {
            console.log(sildesvg2[r])
            const signid = sildesvg2[r].getAttribute('data-id');
            const qianzhang_base64 = sildesvg2[r].children[0].getAttribute('src');
            // const qianzhang_base64 = sildesvg2[r].getAttribute('data-src')
            let v_s_num = that.scale / 2;
            const eleImgCover = await pdfDoc.embedPng(qianzhang_base64);
            const width = sildesvg2[r].getAttribute('data-width') * 1;
            const height = sildesvg2[r].getAttribute('data-height') * 1;
            console.log(that.page_pdf_arr2)
            // var thisx = that.page_pdf_arr2[signid].x / that.scale;
            var thisx = ((canvas.getAttribute('width') * v_s_num) / that.scale) - width;
            var thisy = (((canvas.getAttribute('height') * v_s_num) - that.page_pdf_arr2[signid].y) / that.scale) - height;
            console.log(thisx, thisy)
            pages[i].drawImage(eleImgCover, {
              x: thisx,
              y: thisy,
              width: width,
              height: height,
            });
          }
        }


        // @zf drawImage添加图片
        // pages[i].drawImage(eleImgCover, {
        //     x: 0,
        //     y: 0,
        //     width: eleImgCover.width / that.scale,
        //     height: eleImgCover.height / that.scale,
        // });

        // @zf drawText 添加文字
        // 自定义字体包路径，放在 public 目录
        // const fonturl = './font/font.ttf';
        // const fontBytes = await fetch(fonturl).then((res) => res.arrayBuffer());
        // pdfDoc.registerFontkit(fontkit)
        // const customFont = await pdfDoc.embedFont(fontBytes)
        // pages[i].drawText('aaaaddd', {
        //     x: 0,
        //     y: 0,
        //     width: width / that.scale,
        //     height: height / that.scale,
        //     size: 16,
        //     // 自定义字体
        //     font: customFont,
        //     opacity: 0.3,
        // });

      }
      const pdfBytes = await pdfDoc.save();
      that.saveBlob(pdfBytes, 'TestPdf');
    },
    //保存 bolb流
    saveBlob(data, fileName) {
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(new Blob([data], { type: 'application/pdf' }), fileName + '.pdf');
      } else {
        let url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' })); //定义下载的链接
        let link = document.createElement('a'); //创建一个超链接元素
        link.style.display = 'none'; //隐藏该元素
        link.href = url; //创建下载的链接
        link.setAttribute('download', fileName + '.pdf');
        document.body.appendChild(link);
        link.click(); //点击下载
        document.body.removeChild(link); //下载完成移除元素
        window.URL.revokeObjectURL(url); //释放掉blob对象
      }
    },
    openpdf(num) {
      console.log(num)
      const that = this;
      const num2 = num - 1
      const item = that.page_pdf_arr[num2]
      that.dialogVisible2 = true;
      that.openpdf_index = item.index;

      that.pdfDoc.getPage(num).then((page) => {
        console.log(page)
        document.querySelector('.move_canvas').innerHTML = '';
        let canvas = document.getElementById("lookcanvas");
        let ctx = canvas.getContext("2d");
        let viewport = page.getViewport(2);
        //css界面 宽度*0.5
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        canvas.style.width = viewport.width * 0.5 + 'px';
        canvas.style.height = viewport.height * 0.5 + 'px';
        that.dialogVisible_width = canvas.width * 0.5 + 'px';
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        page.render(renderContext);

        // var sildesvg = document.querySelectorAll('.sign-img[data-page="' + i + '"]')

        //获取印章
        for (let key in item.canvasobj) {
          // console.log(key,item.canvasobj[key])
          // item.canvasobj[key]
          // let e = this.$refs.signimg; 
          let e = document.getElementById(key)
          let dom = e.cloneNode(true); //@zf bug多张图片显示同一个印章 
          let left = item.canvasobj[key].x;
          let top = item.canvasobj[key].y;
          this.pos_x = left;
          this.pos_y = top;

          //详情界面 x y 数据()
          item.canvasobj[key].x = left / that.scale;
          item.canvasobj[key].y = top / that.scale;

          dom.style.left = left / that.scale + "px";
          dom.style.top = top / that.scale + "px";
          dom.style.height = e.getAttribute('data-height') * 1 + "px";
          dom.style.width = e.getAttribute('data-width') * 1 + "px";
          document.querySelector('.move_canvas').appendChild(dom);
          document.onmousemove = null;
          document.onmouseup = null;
          dom.onmouseenter = this.mouseenter;
          dom.onmouseleave = this.mouseleave;
          dom.onmousedown = this.moveTo;
          dom.style.display = 'block';
          dom.setAttribute('data-page', item.index)
          //添加一个随机id
          dom.id = item.canvasobj[key].id;
          //添加删除方法
          dom.childNodes[1].onclick = this.deleteIt;
        }

        //获取骑缝章信息
        // let sildesvg2 = document.getElementById("can" + num).children;
        var sildesvg2 = document.querySelectorAll('.qifengsign-img[data-page="' + num2 + '"]')
        if (sildesvg2.length > 0) {
          for (let r = 0; r < sildesvg2.length; r++) {

            let e = sildesvg2[r]
            let dom = e.cloneNode(true);
            let key = e.getAttribute('data-id')
            let left = that.page_pdf_arr2[key].x;
            let top = that.page_pdf_arr2[key].y;
            this.pos_x = left;
            this.pos_y = top;

            // dom.style.left = left / that.scale + "px";
            dom.style.right = '0px';
            dom.style.top = top / that.scale + "px";
            dom.style.height = e.getAttribute('data-height') * 1 + "px";
            dom.style.width = e.getAttribute('data-width') * 1 + "px";
            document.querySelector('.move_canvas').appendChild(dom);
            document.onmousemove = null;
            document.onmouseup = null;
            dom.style.display = 'block';


          }
        }

      });
    },
    GetRandStr(len) {
      var codeChars = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);

      var codeLength = parseInt(len);
      var code = "";

      for (var i = 0; i < codeLength; i++) {
        //获取随机验证码下标
        var charNum = Math.floor(Math.random() * 10);
        //组合成指定字符验证码
        code += codeChars[charNum];
      }
      return code;
    },
    changesignimg(item){
      console.log('changesignimg',item)
      this.signimage.url = item.url;
      this.signimage.width = item.width;
      this.signimage.height = item.height;
    },
    dialogVisible_close() {
        console.log('关闭，调整印章位置')
        console.log(this.page_pdf_arr[this.openpdf_index])
        document.querySelector('.move_canvas').innerHTML = '';
        const item = this.page_pdf_arr[this.openpdf_index];

        for (let key in item.canvasobj) {
            const odiv = document.getElementById(key);
            const left = item.canvasobj[key].x;
            const top = item.canvasobj[key].y;
            odiv.style.left = left * this.scale + "px";
            odiv.style.top = top * this.scale + "px";

            //把数据记录上
            item.canvasobj[key].x = left * this.scale;
            item.canvasobj[key].y = top * this.scale;
        }
    },
    changesignqz(status) { //status = true 代表下载pdf，首先渲染完毕骑缝章，在执行下载文件
      this.showEdges = !this.showEdges
      console.log('this.showEdges', this.showEdges)
      if (this.showEdges) {
        this.dialogVisible3 = true;
        this.openpdf_qifen(1)
        // this.page_num = 1
        // this.jump()

      } else {
        this.performQifengSplit()
        
      }
    },
    // 执行骑缝章分割
    performQifengSplit(){
      //会重复，如果存在不添加，减少性能效果
      for (const key in this.page_pdf_arr2) {
        // console.log(key,this.page_pdf_arr2[key],this.page_count)
        if (this.page_pdf_arr2[key]) {

          if(this.page_pdf_arr2[key]['moveoff']){ //代表移动过印章 重新生成
            //清除之前旧印章数据
            const elements = document.querySelectorAll(`[data-id="${key}"]`);
            // 遍历所有选中的元素并删除它们
            elements.forEach(element => {
                element.remove();
            });

            console.log('this.scale', this.scale)
            //拆分图片 加层判断，如何页面是几千页，一个章肯定盖不完全，所以判断，当前骑缝章登记小于10px则，重新添加印章
            let canvas = document.getElementById('canvas-3');
            let context3 = canvas.getContext('2d');
            // let width = this.page_pdf_arr2[key]['width'] * this.scale;
            // let height = this.page_pdf_arr2[key]['height'] * this.scale;
            let width = this.page_pdf_arr2[key]['width']; 
            let height = this.page_pdf_arr2[key]['height'];
            context3.clearRect(0, 0, width, height);
            //画图案
            let img2 = document.getElementById(key).children[0]
            console.log(img2)
            context3.drawImage(img2, 0, 0, width, height)

            let locationArr = [];
            let numberX = this.page_count; //总页数
            let numberY = 1; //第几页
            let i = 1;
            let splaceX = '';
            // let canvasH = this.page_pdf_arr2[key]['height'] * this.scale //高度
            // let canvasW = this.page_pdf_arr2[key]['width'] * this.scale //宽度
            let canvasH = this.page_pdf_arr2[key]['height'] //高度
            let canvasW = this.page_pdf_arr2[key]['width'] //宽度

            // console.log((canvasW / numberX))
            if ((canvasW / numberX) < 10) {
              // console.log('canvasW',canvasW)
              //根据最小10px ，反算需要宽度是多少
              let canvasW2 = numberX * 10;
              //需要的长度 / 现有的长度 = 需要几个画布
              let nedcanvas = Math.ceil(canvasW2 / canvasW);

              let creacanvas = document.createElement('canvas');
              creacanvas.width = canvasW2;
              creacanvas.height = canvasH;
              let creactx = creacanvas.getContext('2d');
              for (var ii = 0; ii < nedcanvas; ii++) {
                //横向插图片，x不变 
                let endy = ii * canvasW;
                // console.log(endy)
                creactx.drawImage(canvas, endy, 0)
              }

              //重新替换现有的数据，
              canvas = creacanvas;
              canvasW = creacanvas.width;
              canvasH = creacanvas.height;
            }

            //  将图片等分
            for (var x = 0; x < numberX; x++) {
              for (var y = 0; y < numberY; y++) {
                // splaceX = (canvasW/maxindex)*x
                splaceX = i;
                var location = {
                  'x': x * canvasW / numberX - i,
                  // 'y' : y * canvasH / numberY -splaceY,
                  'y': y * canvasH / numberY,
                  'Dx': x * canvasW / numberX + canvasW / numberX,
                  'Dy': y * canvasH / numberY + canvasH / numberY,
                  'locationOption': (x + 1).toString() + (y + 1).toString(),
                };
                // console.log(location)
                locationArr.push(location);
                this.cropImage(canvas, (x * canvasW / numberX) - splaceX, (y * canvasH / numberY), canvasW / numberX, canvasH / numberY, (x + 1).toString(), x, key, splaceX,status);
                i++
              };
            };
          }
        }
      }
    },
    cropImage(targetCanvas, x, y, owidth, oheight, mathoenumber, mathoenumber2, key, splaceX,status) {
      try {
        const width = owidth;
        const height = oheight;
        var targetctx = targetCanvas.getContext('2d');
        var targetctxImageData = targetctx.getImageData(x, y, width, height);
        // sx, sy, sWidth, sHeight
        var c = document.createElement('canvas');
        var ctx = c.getContext('2d');
        c.width = width; //根据界面，进行缩放
        c.height = height;

        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, width, height);

        ctx.fill();
        ctx.putImageData(targetctxImageData, 0, 0);

        const base64Data = c.toDataURL('image/png');

        //也改成div试试
        var div_p = document.createElement('div');
        div_p.className = 'qifengsign-img'
        div_p.setAttribute('data-page', mathoenumber2)
        div_p.setAttribute('data-id', key)
        div_p.setAttribute('data-width', width)
        div_p.setAttribute('data-height', height)
        div_p.style.position = 'absolute';
        div_p.style.top = this.page_pdf_arr2[key].y + 'px';
        div_p.style.right = '0px'
        div_p.style.width = (width * this.scale) + 'px';  // 显示宽度 = 实际宽度 * this.scale
        div_p.style.height = (height * this.scale) + 'px';// 显示高度 = 实际高度 * this.scale

        var div_img = document.createElement('img');
        div_img.src = base64Data;
        div_img.style.width = '100%'
        div_img.style.height = '100%'
        div_p.appendChild(div_img)
        document.getElementById('can' + splaceX).appendChild(div_p);

        this.page_pdf_arr2[key]['moveoff'] = false;

        if(status && splaceX== this.page_count){ //最后一页，并执行下载pdf操作
          this.savepdf()
        }

      } catch (e) {
        console.log(e)
      }
    },
    openpdf_qifen(num){
      const that = this;
      const num2 = num - 1
      const item = that.page_pdf_arr[num2]
      that.openpdf_index = item.index; 

      that.pdfDoc.getPage(num).then((page) => {
        console.log(page)
        document.querySelector('.move_canvas2').innerHTML = '';
        let canvas = document.getElementById("lookcanvas2");
        let ctx = canvas.getContext("2d");
        let viewport = page.getViewport(2);
        //css界面 宽度*0.5
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        canvas.style.width = viewport.width * 0.5 + 'px';
        canvas.style.height = viewport.height * 0.5 + 'px';
        that.dialogVisible_width2 = (canvas.width * 0.5 + 220) + 'px';
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        page.render(renderContext);

        // var sildesvg = document.querySelectorAll('.sign-img[data-page="' + i + '"]')
        //保存预览canvsa宽高信息，用于界面
        that.openpdf_qifenview.width = canvas.style.width
        that.openpdf_qifenview.height = canvas.style.height

        //获取印章
        for (let key in item.canvasobj) {
          // console.log(key,item.canvasobj[key])
          // item.canvasobj[key]
          // let e = this.$refs.signimg; 
          let e = document.getElementById(key)
          let dom = e.cloneNode(true); //@zf bug多张图片显示同一个印章 
          let left = item.canvasobj[key].x;
          let top = item.canvasobj[key].y;
          // this.pos_x = left;
          // this.pos_y = top;

          //详情界面 x y 数据()
          // item.canvasobj[key].x = left / that.scale;
          // item.canvasobj[key].y = top / that.scale;

          dom.style.left = left / that.scale + "px";
          dom.style.top = top / that.scale + "px";
          dom.style.height = e.getAttribute('data-height') * 1 + "px";
          dom.style.width = e.getAttribute('data-width') * 1 + "px";
          document.querySelector('.move_canvas2').appendChild(dom);
          document.onmousemove = null;
          document.onmouseup = null;
          dom.style.display = 'block';
          dom.setAttribute('data-page', item.index)
          //添加一个随机id
          dom.id = item.canvasobj[key].id;
        }

        //获取骑缝章信息
        var sildesvg2 = document.querySelectorAll('.qifengsign-img[data-page="' + num2 + '"]')
        if (sildesvg2.length > 0) {
          for (let r = 0; r < sildesvg2.length; r++) {

            let e = sildesvg2[r]
            let dom = e.cloneNode(true);
            let key = e.getAttribute('data-id')
            let left = that.page_pdf_arr2[key].x;
            let top = that.page_pdf_arr2[key].y;
            // this.pos_x = left;
            // this.pos_y = top;

            // dom.style.left = left / that.scale + "px";
            dom.style.right = '0px';
            dom.style.top = top / that.scale + "px";
            dom.style.height = e.getAttribute('data-height') * 1 + "px";
            dom.style.width = e.getAttribute('data-width') * 1 + "px";
            console.log(dom.style.height)
            console.log(dom.style.height)
            console.log(that.page_pdf_arr2[key])
            document.querySelector('.move_canvas2').appendChild(dom);
            document.onmousemove = null;
            document.onmouseup = null;
            dom.style.display = 'block';
          }
        }

      });
    },
    closedialogVisible3(){
      this.showEdges = !this.showEdges
      this.dialogVisible3 = false;
    },
    suredialogVisible3(){
      this.showEdges = !this.showEdges
      this.dialogVisible3 = false;
      this.performQifengSplit()
    },
  }
}
</script>

<style scoped>
.opensignimgs {
  min-height: 150px;
  height: auto;
}

.es-pdf-page__edges {
  /* border: 1px solid red; */
  /* background-color: red; */
}

.page__edges_padding {
  padding-right: 150px;
}

.pdfContent_1PW2f .es-pdf-page__edges,.lookcanvasdiv .es-pdf-page__edges {
  z-index: 0;
  background: url(data:image/png;base64,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);
  background-size: cover;
}

.lookcanvasdiv .es-pdf-page__edges{
  position: absolute;
  top: 0;
  left: 99.5%;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  z-index: 0;
  background-size: cover;
}

.es-pdf-page__edges--visible {
  border: 2px dashed #2981d9;
}

.seal-wrapper-item {
  border: 0px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.upfilenbtn{
  margin: 10px 0px;
}
.avatar {
  /* width: 178px; */
  max-height: 178px;
  max-width: 220px;
  display: block;
  box-shadow: 0px 0px 4px #928282;
  margin: 16px 4px;
}
.upfilename{
  font-weight: 500;color: #000;font-size: 12px;
}


.lookcanvasdiv2{
  position: relative;
}
.addqfsign{
  position: absolute;
    top: 0;
    /* left: 99.5%; */
    /* right: -140px;  */
    height: 52px;
    /* width: 0px; */
    writing-mode: vertical-rl;
    background: #409EFF;
    color: #fff;
    letter-spacing: 2px;
    text-align: center;
    cursor: pointer;
}

.delete{
    width: 100%;
    position: absolute;
    bottom: -15px;
    text-align: center;
    color: #fff;
    font-size: 15px;
    background-color: hsla(0, 0%, 4%, 0.6);
    cursor: pointer;
    display: none;
}
</style>
